export default "__VITE_ASSET__Cx32w4Q7__"